<div class="d-flex py-3">
  <div class="project__menu" *ngIf="!czyPracownikKlienta && !czyMobile">
    <a
      *ngIf="!czySpisSamodzielnyKlienta || czyAdmin"
      [ngClass]="aktywnyAdres == 'project-details' ? 'active' : ''"
      routerLink="/project-details/{{ idProjektu }}"
      >Projekt</a
    >
    <a
      [ngClass]="aktywnyAdres == 'inventory' ? 'active' : ''"
      routerLink="/inventory/{{ idProjektu }}"
      >Spis</a
    >
    <a
      [ngClass]="aktywnyAdres == 'locations' ? 'active' : ''"
      routerLink="/locations/{{ idProjektu }}"
      >Lokalizacje</a
    >
    <a
      [ngClass]="aktywnyAdres == 'client-data' ? 'active' : ''"
      routerLink="/client-data/{{ idProjektu }}"
      >Ewidencja klienta</a
    >
    <a
      [ngClass]="aktywnyAdres == 'project-dictionaries' ? 'active' : ''"
      routerLink="/project-dictionaries/{{ idProjektu }}"
      *ngIf="czyAdmin"
      >Słowniki</a
    >
    <a
      [ngClass]="aktywnyAdres == 'teams' ? 'active' : ''"
      routerLink="/teams/{{ idProjektu }}"
      *ngIf="czyAdmin"
      >Zespoły</a
    >
    <a
      [ngClass]="aktywnyAdres == 'users-statistics' ? 'active' : ''"
      routerLink="/users-statistics/{{ idProjektu }}"
      *ngIf="czyAdmin && rodzajProjektu == 1"
      >Statystki pracowników</a
    >
    <a
      [ngClass]="aktywnyAdres == 'inventory-fields' ? 'active' : ''"
      routerLink="/inventory-fields/{{ idProjektu }}"
      *ngIf="czyAdmin"
      >Pola spisu</a
    >
    <a
      *ngIf="czyAdmin"
      [routerLink]="['/admin/reports-edit']"
      [queryParams]="{projekty: idProjektu}"
      >Raporty</a
    >
  </div>
</div>

<div class="d-fledx py-3 d-md-none" *ngIf="!czyPracownikKlienta && czyMobile">
  <div class="project__menu">
    <button class="btn__left"></button>
    <ngx-slick-carousel
      class="carousel menu_slider"
      #slickModal="slick-carousel"
      [config]="slideConfig"
    >
      <div
        ngxSlickItem
        class="slide"
        *ngIf="!czySpisSamodzielnyKlienta || czyAdmin"
      >
        <a
          [ngClass]="aktywnyAdres == 'project-details' ? 'active' : ''"
          routerLink="/project-details/{{ idProjektu }}"
          >Projekt</a
        >
      </div>
      <div ngxSlickItem class="slide">
        <a
          [ngClass]="aktywnyAdres == 'inventory' ? 'active' : ''"
          routerLink="/inventory/{{ idProjektu }}"
          >Spis</a
        >
      </div>
      <div ngxSlickItem class="slide">
        <a
          [ngClass]="aktywnyAdres == 'locations' ? 'active' : ''"
          routerLink="/locations/{{ idProjektu }}"
          >Lokalizacje</a
        >
      </div>
      <div ngxSlickItem class="slide">
        <a
          [ngClass]="aktywnyAdres == 'client-data' ? 'active' : ''"
          routerLink="/client-data/{{ idProjektu }}"
          >Ewidencja klienta</a
        >
      </div>
      <div ngxSlickItem class="slide" *ngIf="czyAdmin">
        <a
          [ngClass]="aktywnyAdres == 'project-dictionaries' ? 'active' : ''"
          routerLink="/project-dictionaries/{{ idProjektu }}"
          >Słowniki</a
        >
      </div>
      <div ngxSlickItem class="slide" *ngIf="czyAdmin">
        <a
          [ngClass]="aktywnyAdres == 'teams' ? 'active' : ''"
          routerLink="/teams/{{ idProjektu }}"
          >Zespoły</a
        >
      </div>
      <div ngxSlickItem class="slide" *ngIf="czyAdmin && rodzajProjektu == 1">
        <a
          [ngClass]="aktywnyAdres == 'users-statistics' ? 'active' : ''"
          routerLink="/users-statistics/{{ idProjektu }}"
          >Statystki pracowników</a
        >
      </div>
      <div ngxSlickItem class="slide" *ngIf="czyAdmin">
        <a
          [ngClass]="aktywnyAdres == 'inventory-fields' ? 'active' : ''"
          routerLink="/inventory-fields/{{ idProjektu }}"
          >Pola spisu</a
        >
      </div>
      <div ngxSlickItem class="slide" *ngIf="czyAdmin">
        <a
          [routerLink]="['/admin/reports-edit']"
          [queryParams]="{projekty: idProjektu}"
          >Raporty</a
        >
      </div>
    </ngx-slick-carousel>
    <button class="btn__right"></button>
  </div>
</div>
